var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"hiq-header__button hiq-header__button--menu",class:{'expanded': _vm.showMenu},attrs:{"aria-label":"Huvudnavigering","aria-controls":"menu","aria-expanded":_vm.showMenu ? 'true' : 'false',"data-ignore-close":""},on:{"click":function($event){return _vm.toggleMenu()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }